import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  FONT_FAMILY_INPUT: `${cleanedFilename(__filename)}-font-family-input`,
};
